import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import copy from 'fast-copy'

import TimeField from 'vendor/time-field'

import { 
	timeStringFromSession,
	momentToApiTimeFormat,
	getSessionSeconds,
	getSessionsFromTimeInput
} from 'utils'

import moment from 'moment'

export default class DashboardTimeTrackingSession extends Component {
	task = null
	milestone = null
	project = null
	forceUpdateInterval = null

	state = {
		isBeingEdited: false,
		tempTimeInput: timeStringFromSession(this.props.session)
	}

	componentWillMount() {
		this.assessForceUpdateInterval()
	}

	componentWillUpdate = (nextProps, nextState) => {
		const currentTimeString = timeStringFromSession(this.props.session)
		const nextTimeString = timeStringFromSession(nextProps.session)

		if(currentTimeString !== nextTimeString && !nextState.isBeingEdited){
			this.setState({
				tempTimeInput: nextTimeString
			})
		}

		this.assessForceUpdateInterval(nextProps)
	}

	assessForceUpdateInterval = (props = this.props) => {
		if(!this.forceUpdateInterval && props.session && !props.session.stopped_at){
			this.forceUpdateInterval = setInterval(_ => {
				if(this.props.session && !this.props.session.stopped_at){
					this.forceUpdate()
				}else{
					clearInterval(this.forceUpdateInterval)
				}
			},1000)
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if(!prevState.isBeingEdited && this.state.isBeingEdited){
			this.inputRef.focus()
		}
	}

	cancelEditSession = _ => {
		this.setState({
			isBeingEdited: false,
			tempTimeInput: timeStringFromSession(this.props.session)
		})
	}

	editSession = session => {
		const value = timeStringFromSession(session)

		this.setState({
			isBeingEdited: true,
			tempTimeInput: value
		})
	}

	deleteSession = _ => {
		let clonedSession = copy(this.props.session)

		if(this.task && this.task.name){
			clonedSession.task = this.task
			clonedSession.task.milestone = this.milestone
			clonedSession.task.milestone.project = this.project
		}else{
			clonedSession.task = {
				id: -1,
				name: '(Archived task)',
				milestone: {
					id: -1,
					name: '',
					project: this.project
				}
			}
		}

		this.props.openModal('delete', 'session', clonedSession)
	}

	handleChangeTimeTemp = value => {
		this.setState({
			tempTimeInput: value
		})
	}

	saveSession = session => {
		const timeString = this.state.tempTimeInput
		const totalSeconds = getSessionsFromTimeInput(timeString)

		const newStoppedAtMoment = moment(session.created_at).add(totalSeconds, 'seconds')
		const newStoppedAtValue = momentToApiTimeFormat(newStoppedAtMoment)

		let newSession = copy(session)

		newSession.stopped_at = newStoppedAtValue

		this.props.saveItem(newSession, 'session')
		this.cancelEditSession()
	}

	getTaskName = _ => {
		let taskName = this.task.name

		if(this.task.deleted_at){
			taskName += ' (Archived)'
		}

		return taskName
	}

	getProjectName = _ => {
		if(this.project && this.project.name){
			return this.project.name
		}else{
			return '(A deleted project)'
		}
	}

	render() {
		const {
			allTasks,
			allMilestones,
			allProjects,
			session,
			canEdit
		} = this.props

		const {
			tempTimeInput,
			isBeingEdited
		} = this.state

		const totalSeconds = getSessionSeconds(session, true)

		if(totalSeconds < 1){
			return null
		}

		this.task = allTasks[session.task_id]

		if(!this.task){
			return null
		}

		this.milestone = allMilestones[this.task.milestone_id]

		this.project = allProjects[session.project_id]

		if (!this.project) {
			return null
		}

		const originalLengthTimeString = timeStringFromSession(session)
		const isRunningSession = session && !session.stopped_at

		let className = ''

		if(isBeingEdited){
			className += ' edited'
		}
		
		if(!canEdit){
			className += ' no-edit'
		}

		if(isRunningSession){
			className += ' running'
		}

		return (
			<li
				key={session.id}
				className={className}
			>
				<TimeField
					onChange={this.handleChangeTimeTemp}
					value={session && !session.stopped_at ? originalLengthTimeString : tempTimeInput}
					disabled={!isBeingEdited}
					placeholder={originalLengthTimeString}
					onKeyPress={e => {(e.key === 'Enter') ? this.saveSession(session) : null }}
					input={<input type="text" ref={ref => this.inputRef = ref} />}
					colon=":"
					showSeconds={isRunningSession}
				/>
				<div>
					<span>
						{ isRunningSession ? 
							<em className={'online-dot visible'} />
						: null }
						{ this.getTaskName() }
					</span>
					<label>
						{ this.getProjectName() } { this.milestone ? ' • '+this.milestone.name : ''}
					</label>
				</div>
				{ canEdit &&
					<div className="controls">
						{isBeingEdited ?
							<div>
								<button
									onClick={_ => {
										this.saveSession(session)
									}}
								>
									<Icon name="check" />
								</button>
								<button
									onClick={this.cancelEditSession}
								>
									<Icon name="ban" />
								</button>
							</div>
							:
							<div>
								<button 
									className="tooltip-trigger" 
									onClick={_ => {
										this.editSession(session)
									}}>
									<Icon name="fe-edit-2" />
									<div className="tooltip">
										Edit time
									</div>
								</button>
								<button 
									className="tooltip-trigger"
									onClick={this.deleteSession}
								>
									<Icon name="fe-trash-2" />
									<div className="tooltip">
										Delete session
									</div>
								</button>
							</div>
						}
					</div>
				}
			</li>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-time-tracking-session.jsx